import AsyncStorage from '@react-native-async-storage/async-storage';

/** Bump the suffix to teach the gesture again after it changes. */
const LONG_PRESS_KEY = 'hint/long-press-v1';

/**
 * Whether the "hold a name" hint is still owed to this install.
 *
 * A failed read reports "already seen": a storage error that repeated the hint
 * every single round would be far more annoying than one that skips it.
 */
export async function shouldShowLongPressHint(): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(LONG_PRESS_KEY)) === null;
  } catch {
    return false;
  }
}

/**
 * Call once the hint has actually been put on screen — not when it's scheduled.
 * A crash before it renders should leave the one showing intact for next time.
 */
export async function markLongPressHintSeen(): Promise<void> {
  try {
    await AsyncStorage.setItem(LONG_PRESS_KEY, '1');
  } catch {
    // Worst case they get the hint once more. Not worth surfacing.
  }
}
